import React from "react";
import { Container } from "react-bootstrap";
import { AiFillLinkedin, AiFillMail } from "react-icons/ai";

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <div className="footer-content">
          <div className="footer-text">
            Debojyoti Roy | Personal Portfolio
          </div>
          <div className="footer-socials">
            <a
              href="https://linkedin.com/in/debojyotir"
              target="_blank"
              rel="noreferrer"
              title="LinkedIn"
            >
              <AiFillLinkedin />
            </a>
            <a href="mailto:debojyotir2025@gmail.com" title="Email">
              <AiFillMail />
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
